import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types'

import VideoRoutes from './Routes/VideoRoutes'
import ImageRoutes from './Routes/ImageRoutes'
import AdCreateRouteSelector from './Steps/AdCreateRouteSelector'

import useStepFormRoutes from '../../../../../hooks/formHooks/useStepFormRoutes'
import useIsInternalAdCreation from '../../../../../features/hooks/internalAdHooks/useIsInternalAdCreation'

import { clearCreateAd } from '../../../../../modules/actions/ads'
import {
  adCreateErrorSelector,
  adCreateLoadingSelector,
  adWasCreatedSelector
} from '../../../../../modules/selectors/ads'
import { gamRightUploadAdDataSelector } from '../../../../../modules/selectors/rights'

import { ENVIRONMENT_TYPE, environmentTypes } from '../LineItemForm/fields'
import { AD_GAM_CREATE } from '../../../../../constants/forms'
import { IMAGE_UPLOAD_TYPE, VIDEO_UPLOAD_TYPE } from './fields'

const AdGamCreateForm = ({ formProgressItems, onSuccessSubmit }) => {
  const dispatch = useDispatch()

  const { lineItem } = useSelector(gamRightUploadAdDataSelector)
  const adWasCreated = useSelector(adWasCreatedSelector)

  const adType = lineItem[ENVIRONMENT_TYPE]

  const isInternalAdCreation = useIsInternalAdCreation()
  const manageStepFormRoutes = useStepFormRoutes({
    // BROWSER is image ad, VIDEO_PLAYER is video ad
    initialRoute: adType === environmentTypes.BROWSER ? IMAGE_UPLOAD_TYPE : VIDEO_UPLOAD_TYPE
  })

  const clearCreateAdHandler = useCallback(() => {
    dispatch(clearCreateAd())
  }, [dispatch])

  const routeProps = {
    selectedRoute: manageStepFormRoutes.selectedRoute,
    formName: AD_GAM_CREATE,
    successSubmit: adWasCreated,
    errorSelector: adCreateErrorSelector,
    isLoadingSelector: adCreateLoadingSelector,
    // this allow to clearCreateAd on error
    clearSubmitHandler: clearCreateAdHandler,
    // FormRouteSelector component is adding in each Route as a first step and allows to control Route Selecting
    FormRouteSelector: <AdCreateRouteSelector manageStepFormRoutes={manageStepFormRoutes} adType={adType} />,
    isInternalAdCreation,
    onSuccessSubmit,
    formProgressItems
  }

  return adType === environmentTypes.BROWSER ? <ImageRoutes {...routeProps} /> : <VideoRoutes {...routeProps} />
}

AdGamCreateForm.propTypes = {
  formProgressItems: PropTypes.array,
  onSuccessSubmit: PropTypes.func
}

export default AdGamCreateForm
